import { render, staticRenderFns } from "./widget-editor-layout.vue?vue&type=template&id=7f4b6fe0&scoped=true&"
import script from "./widget-editor-layout.vue?vue&type=script&lang=js&"
export * from "./widget-editor-layout.vue?vue&type=script&lang=js&"
import style0 from "./widget-editor-layout.vue?vue&type=style&index=0&id=7f4b6fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b6fe0",
  null
  
)

export default component.exports